import { Box } from "@mui/material"
import { If } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AuthoringEditorInlineRejectionBanner } from "./authoring-editor-inline-rejection-banner"

export function AuthoringReviewPriorRejection({ amendsKey }) {
    const { rejectionsByAmendsKey } = useBoundContext()

    const rejection = amendsKey ? rejectionsByAmendsKey[amendsKey] ?? null : null

    return (
        <If truthy={!!rejection}>
            <Box width={1} sx={{ mb: 1 }} data-cy="review-prior-rejection">
                <AuthoringEditorInlineRejectionBanner
                    decision={rejection}
                    title={getRejectionTitle(rejection)}
                    outlined
                />
            </Box>
        </If>
    )
}

function getRejectionTitle(rejection) {
    const reviewCycle = rejection?.payload?.reviewCycle
    if (!Number.isFinite(Number(reviewCycle))) return "Previously Rejected"
    return `Rejected in Review Cycle ${reviewCycle}`
}
